export enum CharacteristicTypeNameEnum {
    Job = 'job',
    Sample = 'sample',
    Study = 'study',
    Taxon = 'taxon'
}
